import { INVENTORY_DATA } from "constants/action-types";
import { IDownloadParams } from "containers/admin/data/inventory-data-page";
import { Dispatch } from "redux";
import { IStore } from "reducers";
import { IInventoryDataState } from "reducers/inventory-data-reducers";
import { FileWithPreview } from "react-dropzone";

export const uploadInventoryDataNonVetl = (file: FileWithPreview) => (dispatch: Dispatch<{}>) => {
    const body = new FormData();
    body.append("file", file);
    dispatch({ type: INVENTORY_DATA.UPLOAD_NON_VETL.START, payload: { url: "/assets/sync/inventory", body } });
};

export const uploadInventoryData = (result) => ({
    type: INVENTORY_DATA.UPLOAD.START,
    payload: { url: "/api/v3.0/vetl/inventory-data/upload", body: result },
});

export const startInventoryDataUploadJobPolling = (payload) => ({ type: INVENTORY_DATA.JOB.POLL.START, payload });

export const fetchInventoryDataUploadJob = (jobId: string, pipelineId: string) => ({
    type: INVENTORY_DATA.JOB.FETCH.START,
    payload: { url: "/api/v3.0/vetl/job", body: { jobId, pipelineId } },
});

export const download = (body: IDownloadParams) => (dispatch: Dispatch<{}>) => {
    dispatch(update({ isLoading: true }));
    dispatch({
        type: INVENTORY_DATA.DOWNLOAD,
        payload: { url: "/api/v3.0/inventory/export", body },
    });
};

export const downloadAts = () => (dispatch: Dispatch<{}>, getState: () => IStore) => {
    dispatch(update({ isLoading: true }));
    dispatch({
        type: INVENTORY_DATA.DOWNLOAD_ATS,
        payload: { url: `/products/inventory/export/ats/${getState().scope.brand._id}` },
    });
};

export const deleteAll = () => ({ type: INVENTORY_DATA.DELETE_ALL, payload: { url: "/products/clear-all-inventory" } });
export const update = (payload: Partial<IInventoryDataState>) => ({ type: INVENTORY_DATA.UPDATE, payload });
